// extracted by css-extract-rspack-plugin
export default {"FacetOption":"FacetOption-module__FacetOption__dYl2L","TrailingAction":"FacetOption-module__TrailingAction__YsNG6","TruncateWrap":"FacetOption-module__TruncateWrap___6hcs"};